import React, {useState, useEffect} from "react";
import {Tooltip, Modal, Upload, Button, Space, Table, DatePicker, Select} from "antd";
import {useStore} from "../../../../hooks/useStore";
import {CopyForecastButtonContainer} from "./CopyForecastButton.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {message} from "antd";

const CopyForecastButton = ({poolOptions = [], poolOptionsLoading = false}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const stores = useStore();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [poolIds, setPoolIds] = useState([]);
    const [copyResult, setCopyResult] = useState(null);
    const [selectedPools, setSelectedPools] = useState([]);
    const [poolList, setPoolList] = useState([]);
    const [processedPools, setProcessedPools] = useState([]);

    useEffect(() => {
        const fetchPools = async () => {
            try {
                if (!poolOptions?.data) {
                    return;
                }

                const pools = poolOptions.data.map(pool => ({
                    key: pool._id,
                    poolName: pool.name,
                    id: pool._id
                }));
                setPoolList(pools);
            } catch (error) {
                console.error("Havuz listesi yükleme hatası:", error);
                if (!poolOptions?.data) {
                    message.error("Havuz listesi yüklenirken hata oluştu");
                }
            }
        };
        fetchPools();
    }, [poolOptions]);

    const handleModalClose = () => {
        setIsModalOpen(false);
        setCopyResult(null);
        setProcessedPools([]);
    };

    const handleCopyForecast = async () => {
        try {
            setLoading(true);
            if (!fromDate || !toDate || !poolIds.length) {
                message.error("Lütfen tüm alanları doldurun");
                return;
            }

            const params = {
                fromDate: fromDate.format("YYYY-MM-DD"),
                toDate: toDate.format("YYYY-MM-DD"),
                poolIds: poolIds
            };

            setProcessedPools([...poolIds]);

            const response = await stores.poolShiftStore.copyForecast(params);

            if (response.data.errors.length === 0) {
                message.success("Forecast başarıyla kopyalandı");
                handleModalClose();
            } else {
                message.error("Bazı havuzlarda hata oluştu");
                setCopyResult(response.data);
            }
        } catch (error) {
            message.error(
                error.response?.data?.message || "Forecast kopyalama işlemi başarısız oldu"
            );
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const poolColumns = [
        {
            title: "Havuz",
            dataIndex: "poolName",
            key: "poolName"
        },
        {
            title: "Durum",
            dataIndex: "status",
            key: "status",
            render: (_, record) => {
                if (!processedPools.includes(record.id)) {
                    return "-";
                }

                if (copyResult?.errors) {
                    const error = copyResult.errors.find(err => err.poolId === record.id);
                    return error ? (
                        <span style={{color: "red"}}>{error.error}</span>
                    ) : (
                        <span style={{color: "green"}}>Başarılı</span>
                    );
                }
                return "-";
            }
        }
    ];

    const onSelectPoolChange = selectedRowKeys => {
        setSelectedPools(selectedRowKeys);
        setPoolIds(selectedRowKeys);
    };

    const poolRowSelection = {
        selectedRowKeys: selectedPools,
        onChange: onSelectPoolChange
    };

    return (
        <CopyForecastButtonContainer>
            <Tooltip title={"Vardiya Yükle"}>
                <Button type="primary" onClick={() => setIsModalOpen(true)}>
                    Forecast Kopyala
                </Button>
            </Tooltip>

            <Modal
                title="Forecast Kopyalama"
                visible={isModalOpen}
                onOk={handleCopyForecast}
                onCancel={handleModalClose}
                confirmLoading={loading}
                footer={[
                    <Button key="close" onClick={handleModalClose}>
                        Kapat
                    </Button>,
                    <Button
                        key="copy"
                        type="primary"
                        loading={loading}
                        onClick={handleCopyForecast}
                    >
                        Kopyala
                    </Button>
                ]}
                width={800}
                style={{top: 20}}
            >
                <Space direction="vertical" size="middle" style={{width: "100%"}}>
                    <div style={{display: "flex", gap: "20px"}}>
                        <div style={{flex: 1}}>
                            <p>Kaynak Tarih:</p>
                            <DatePicker
                                style={{width: "100%"}}
                                onChange={date => setFromDate(date)}
                                placeholder="Kaynak tarihi seçin"
                            />
                        </div>
                        <div style={{flex: 1}}>
                            <p>Hedef Tarih:</p>
                            <DatePicker
                                style={{width: "100%"}}
                                onChange={date => setToDate(date)}
                                placeholder="Hedef tarihi seçin"
                            />
                        </div>
                    </div>

                    <div>
                        <p>Havuzlar:</p>
                        <Table
                            rowSelection={poolRowSelection}
                            dataSource={poolList}
                            columns={poolColumns}
                            pagination={false}
                            size="small"
                            style={{marginBottom: "16px"}}
                            scroll={{y: 300}}
                        />
                    </div>
                </Space>
            </Modal>
        </CopyForecastButtonContainer>
    );
};

export default CopyForecastButton;
